import { graphql } from '@/generated/gql';

export const INTAKE_REQUEST_LINE_ITEM_STEP_NEXT_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeRequestLineItemNext($data: SvbrgIntakeRequestLineItemNextInput!) {
    sevenbridges {
      chatSession {
        request {
          requestNextLineItems(data: $data) {
            id
            accountingAreaId
            commodityGroupId
            costCenterId
            currency
            deliveryLocationId
            organizationId
            lineItems {
              commodityGroupId
              unitId
              description
              earlyDeliveryAt
              expectedPricePerUnit
              id
              lateDeliveryAt
              position
              quantity
              sequence
              title
            }
          }
        }
      }
    }
  }
`);
